import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import AuthShell from "./AuthShell";

const SuccessMain = () => {
  const location = useLocation();
  const { title, description } = location.state || {};
  return (
    <AuthShell
      title="Success"
      heading={title}
      subheading={description}
      brandHeadline="Back to work in a couple of minutes."
      brandSubcopy="Your projects, schedules and daily progress are exactly where you left them."
    >
      <Link className="pxauth-btn" to={"/"}>
        Login
      </Link>
    </AuthShell>
  );
};
export default SuccessMain;
